import React from "react";
import { SxProps, Typography } from "@mui/material";
import { numeralCustom } from "../../../utils/helpers";

interface ISummary {
  text: string;
  value: number;
  sx?: SxProps;
  onClick?: () => void;
}

function Summary({ text, value, sx, onClick }: ISummary) {
  return (
    <Typography
      onClick={onClick}
      sx={{
        p: 0.5,
        cursor: !!onClick ? "pointer" : "",
        "&:hover": { backgroundColor: !!onClick ? "background.default" : "" },
      }}
    >
      {text}{" "}
      <Typography
        component="span"
        sx={{ color: "success.main", fontWeight: 600, ...sx }}
      >
        {numeralCustom(value).format()}
      </Typography>{" "}
    </Typography>
  );
}

export default Summary;
